import EventEmitter from 'eventemitter3'

export const emitter = new EventEmitter()
export const H5_History_Dialog = 'H5_History_Dialog'
// reset MainContent 的状态
export const RESER_STATE = 'resetState'
export const H5_MASK = 'h5Mask'
